<template>
  <v-container
    id="clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <div>
      <v-row>
        <v-col
          cols="12"
          class="container"
        >
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <dashboard-filtros
                :vendedores="enableVendedores"
                :redes="enableRedes"
                :meses="enableMeses"
                :anos="enableAnos"
                :supervisores="enableSupervisores"
                :btn1="enableBtn"
              />
            </v-col>
          </v-row>
          <v-row id="analiseVendasFiltrosId">
            <v-col
              cols="12"
              sm="2"
              md="2"
              lg="2"
            >
              <v-row v-if="enableBtnPrint">
                <v-btn
                  id="btnPrint"
                  class="col-12 col-sm-12 col-md-12 col-lg-12"
                  small
                  :color="corPrimaria"
                  dark
                  :loading="imprimindo"
                  @click="imprimir()"
                >
                  <v-icon>
                    mdi-printer
                  </v-icon>
                  Imprimir
                  <template v-slot:loader>
                    <span>Imprimindo...</span>
                  </template>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
          <v-row id="bloco1Print">
            <v-col
              id="analiseEquipeVendasId"
              cols="12"
              sm="12"
              md="12"
              lg="4"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      % Faturamento Por Vendedor
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('301')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-analise-equipe-vendas />
                    </v-col>
                  </v-row>
                </v-card-actions><br>
              </v-card>
            </v-col>
            <v-col
              id="faturamentoMetaVendedoresId"
              cols="12"
              sm="12"
              md="12"
              lg="8"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Faturamento x Meta Vendedor - R$
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('302')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-faturamento-meta-vendedores />
                    </v-col>
                  </v-row>
                </v-card-actions><br>
              </v-card>
            </v-col>
          </v-row>
          <v-row id="bloco2Print">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="4"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      % Devoluções Impróprias
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('303')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-devolucao-improprias-vendedores />
                    </v-col>
                  </v-row>
                </v-card-actions><br>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="8"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Devoluções x Orçado Vendedor - R$
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('304')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-devolucao-orcardo-vendedores />
                    </v-col>
                  </v-row>
                </v-card-actions><br>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Cobertura Vendedor
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('338')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-table-cobertura-vendedores />
                    </v-col>
                  </v-row>
                </v-card-actions><br>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row><br>

      <dashboard-core-snackbar
        v-model="snackbar.visible"
        :visible="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :message="snackbar.message"
      />
    </div>
  </v-container>
</template>

<script>
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'
  import html2canvas from 'html2canvas'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardAnaliseEquipeVendas',
    emits: ['setUpdateFiltros', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltros: () => import('../../components/core/FiltrosSaborDaSerra'),
      ShowAnaliseEquipeVendas: () => import('../../graficos/ComercialPersonalizado/AnaliseEquipeVendas'),
      ShowFaturamentoMetaVendedores: () => import('../../graficos/ComercialPersonalizado/FaturamentoMetaVendedores'),
      ShowDevolucaoImpropriasVendedores: () => import('../../graficos/ComercialPersonalizado/DevolucaoImpropriasVendedores'),
      ShowDevolucaoOrcardoVendedores: () => import('../../graficos/ComercialPersonalizado/DevolucaoOrcardoVendedores'),
      showTableCoberturaVendedores: () => import('../../components/comercial/comercialPersonalizado/TableCoberturaVendedores'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleTexto: {
        color: '#00796B',
      },
      paginaEnable: false,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      redes: [],
      ano: [],
      mes: [],
      supervisores: [],
      permissaoAnaliseFaturamento: false,
      enableVendedores: false,
      enableRedes: true,
      enableMeses: true,
      enableAnos: true,
      enableBtn: true,
      enableSupervisores: true,
      enableBtnPrint: false,
      codigo: 0,
      orientacao: [],
      textoPorcentagemFatVendedor: '',
      textoFatxMetaVendedor: '',
      textoDevImpropriaVendedor: '',
      textoDevxOrcadoVendedor: '',
      textoCoberturaVendedor: '',
      codigoIds: ['301', '302', '303', '304', '338'],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      myChart: {},
      chartBarPorcentagemFaturamentoVendedor: {},
      legendaGraficoPorcentagemFaturamentoVendedor: [],
      chartBarFaturamentoMetaVendedores: {},
      legendaGraficoFaturamentoMetaVendedores: [
        { status: 'Vlr Fat', cor: '#00897B' },
        { status: 'Vlr Meta', cor: '#C62828' },
      ],
      dynamicPaddingAnaliseVendas1: '',
      dynamicPaddingAnaliseVendas2: '',
      dynamicPaddingAnaliseVendas3: '',
      imprimindo: false,
      dadosImpressao: [],
      headersImpressao: [],
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('update-dados-filtros', this.handleUpdateDados)

      eventEmit.$on('enable-btn-print', this.handleBtnPrint)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-filtros', this.handleUpdateDados)

      eventEmit.$off('enable-btn-print', this.handleBtnPrint)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Análise Vendas')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingAnaliseVendas1 = 'padding-right: 24rem !important'

          this.dynamicPaddingAnaliseVendas2 = 'padding-right: 65rem !important'

          this.dynamicPaddingAnaliseVendas3 = 'padding-right: 114rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingAnaliseVendas1 = 'padding-right: 17rem !important'

          this.dynamicPaddingAnaliseVendas2 = 'padding-right: 51rem !important'

          this.dynamicPaddingAnaliseVendas3 = 'padding-right: 92rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingAnaliseVendas1 = 'padding-right: 9rem !important'

          this.dynamicPaddingAnaliseVendas2 = 'padding-right: 9rem !important'

          this.dynamicPaddingAnaliseVendas3 = 'padding-right: 9rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingAnaliseVendas1 = 'padding-right: 30rem !important'

          this.dynamicPaddingAnaliseVendas2 = 'padding-right: 30rem !important'

          this.dynamicPaddingAnaliseVendas3 = 'padding-right: 30rem !important'
        } else {
          this.dynamicPaddingAnaliseVendas1 = 'padding-right: 11rem !important'

          this.dynamicPaddingAnaliseVendas2 = 'padding-right: 39rem !important; margin: -1rem 0 0 -1rem'

          this.dynamicPaddingAnaliseVendas3 = 'padding-right: 75rem !important'
        }
      },

      handleUpdateDados (vendedor, redes, mes, ano, supervisores) {
        this.redes = redes
        this.mes = mes
        this.ano = ano
        this.supervisores = supervisores

        this.updateDate()
      },

      handleBtnPrint (enablePrint, headers, dados) {
        this.enableBtnPrint = enablePrint

        this.headersImpressao = headers

        this.dadosImpressao = dados
      },

      updateDate () {
        this.enableBtnPrint = false

        eventEmit.$emit('set-update-filtros', this.redes, this.mes, this.ano, this.supervisores)
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Definir a margem esquerda
          const marginLeftRem = -1
          const marginLeftPx = marginLeftRem * 16
          let posYFiltros = 10

          const title = 'Análise Equipe Vendas'
          pdf.text(title, 105, posYFiltros)

          posYFiltros += 10
          const filtros = 'Filtros Selecionados:'
          pdf.setFontSize(10)
          pdf.text(filtros, 15, posYFiltros)

          const datas = this.mes[0].texto + ' - ' + this.ano
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Supervisor(es) Selecionado(s):', this.supervisores.map(s => s.supervisor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))

          // Função para adicionar tabela e controlar quebra de página
          const addTable = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 15, posY)
            posY += pdf.getTextDimensions(title).h /* + 5 */

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: fontSize, textColor: [0, 0, 0] } }))],
              body: data.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
              startY: posY,
              styles: { fontSize: fontSize },
            })

            posY = 20

            return posY
          }

          if (posYFiltros > 70) {
            pdf.addPage()

            posYFiltros = 10
          }

          // Adicionar a imagem dos filtros usando html2canvas
          const bloco1 = document.getElementById('bloco1Print')
          const canvasBloco1Print = await html2canvas(bloco1)
          const imgWidthBloco1 = 290
          const imgHeightBloco1 = (canvasBloco1Print.height * imgWidthBloco1) / canvasBloco1Print.width

          pdf.addImage(canvasBloco1Print.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidthBloco1, imgHeightBloco1)

          posYFiltros += imgHeightBloco1

          pdf.addPage()
          posYFiltros = 10

          const titleTableGrupoProduto = 'Cobertura Vendedor '
          const tableGrupoProduto = this.dadosImpressao.map(item => [item.vendedor, item.cliente, item.positivados, item.porcentagem, item.semCompra, item.ticket])
          posYFiltros = await addTable(tableGrupoProduto, this.headersImpressao, titleTableGrupoProduto, posYFiltros, 8)

          pdf.addPage()
          posYFiltros = 10

          const bloco2 = document.getElementById('bloco2Print')
          const canvasBloco2Print = await html2canvas(bloco2)
          const imgWidthBloco2 = 290
          const imgHeightBloco2 = (canvasBloco2Print.height * imgWidthBloco2) / canvasBloco2Print.width

          pdf.addImage(canvasBloco2Print.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidthBloco2, imgHeightBloco2)

          pdf.save('relatorio_analise_equipe_vendas.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.faturamentoGrupoProdutosPrint = []
          this.faturamentoLinhaPrint = []
          this.headersTableLinha = []
          this.imprimindo = false
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }

</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #iconInformationPorcentagemFatVendedor {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationFatxMetaVendedor {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationDevImpropriaVendedor {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationDevxOrcadoVendedor {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationCoberturaVendedor {
      margin: -6.8rem 0 0 0;
    }
  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

</style>

<style lang="sass">
  #textoAnaliseFaturamento
    font-size: 36px
    margin: 1.5rem 0 0 0

  #textoFaturamentoPorVendedorId
    margin: 0 0 0 -2rem

  #btnPrint
    margin: 0.5rem 0 2rem 3rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemFaturamentoVendedor
    margin: -2rem 0 0 -1rem

  #listItemFaturamentoMetaVendedor
    margin: -2rem 0 0 -1rem

  @media print
    #app-bar
      display: none !important

    #core-navigation-drawer
      display: none

    #analiseVendasFiltrosId
      margin: -7rem 0 0 0 !important

    #btnRefazer
      display: none

    #btnPrint
      display: none

    #textoAnaliseFaturamento
      font-size: 24px !important
      margin: 1.5rem 0 0 0

    #textoFaturamentoPorVendedorId
      margin: 0 0 0 -65rem !important

    #myChartPorcentagemFaturamentoVendedor
      margin: 5rem 0 0 -10rem !important
      width: 350px !important
      height: 200px !important

    #textoFaturamentoMetaVendedor
      margin: 2.5rem 0 0 0

    #legendaFaturamentoMetaVendedores
      display: none

    #faturamentoMetaVendedoresId
      margin: -25.3rem 0 0 0 !important

    #myChartFaturamentoMetaVendedores
      margin: 1rem 0 2rem 12rem !important
      width: 800px !important
      height: 500px !important

    #devolucaoImpropriasVendedoresId
      margin: 2rem 0 0 -60rem !important

    #myChartDevolucaoImpropriaVendedores
      margin: 5rem 0 0 -10rem !important
      width: 350px !important
      height: 200px !important

    #devolucaoOrcadoVendedoresId
      margin: -21.5rem 0 0 0 !important

    #myChartDevolucaoOrcadoVendedores
      margin: -22rem 0 0 15rem !important
      width: 800px !important
      height: 500px !important

    #legendaDevolucaoOrcadoVendedores
      display: none

    #legendaFatxLinha
      display: none

    #iconInformationPorcentagemFatVendedor
      display: none

    #iconInformationFatxMetaVendedor
      display: none

    #iconInformationDevImpropriaVendedor
      display: none

    #iconInformationDevxOrcadoVendedor
      display: none

    #iconInformationCoberturaVendedor
      display: none

    #divisaId
      margin: 10rem 0 0 0

    #tableCoberturaVendedor
      margin: 0 0 0 -5rem

    .v-data-table__wrapper
      height: auto !important

    #linkDetalhe
      display: none

</style>
